import React from "react";
import { Avatar } from "../shared/Avatar";
import { CustomIcon } from "../shared/CustomIcon";
import { fullName } from "../../lib/format";

// ============================================================
// FilteredMembersModal — opens when a clickable metric is tapped in
// the Membership tab. Shows a scrollable text list of matching members.
// Each row is itself clickable → navigates to that member's profile.
// ============================================================
export default function FilteredMembersModal({ title, sub, members, onClose, navigate }) {
  const count = members.length;
  return (
    <div className="modal-overlay" data-testid="filtered-members-modal" onClick={onClose}>
      <div className="modal fm-modal" onClick={e => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="modal-header">
          <div>
            <div className="modal-title" data-testid="fm-modal-title">{title}</div>
            {sub && <div className="fm-modal-sub">{sub}</div>}
            <div className="fm-modal-count" data-testid="fm-modal-count">
              {count} member{count === 1 ? "" : "s"}
            </div>
          </div>
          <button className="modal-close" data-testid="fm-modal-close" onClick={onClose} aria-label="Close">×</button>
        </div>
        <div className="modal-body fm-modal-body">
          {count === 0 ? (
            <div className="empty"><div className="empty-icon"><CustomIcon name="people" size={40} /></div><div className="empty-text">No members match this filter.</div></div>
          ) : (
            <div className="fm-list">
              {members.map(m => (
                <div
                  key={m.id}
                  role="button"
                  tabIndex={0}
                  className="fm-row"
                  data-testid={`fm-row-${m.id}`}
                  onClick={() => { onClose(); navigate(`/members/${m.id}`); }}
                  onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClose(); navigate(`/members/${m.id}`); } }}
                >
                  <Avatar name={fullName(m)} photo={m.photo} memberId={m.id} status={m.memberStatus} style={{ width: 32, height: 32, fontSize: 11 }} />
                  <div className="fm-row-main">
                    <div className="fm-row-name">{fullName(m)}</div>
                    <div className="fm-row-meta">
                      {m.memberStatus || "—"}
                      {m.departments && m.departments[0] ? ` · ${m.departments[0]}` : ""}
                      {m.language ? ` · ${m.language}` : ""}
                    </div>
                  </div>
                  <span className="fm-row-arrow" aria-hidden="true">›</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
